// removed by extract-text-webpack-plugin
module.exports = {"stickyHeader":"_2qbxfQF","stickyHeader__sidePanelOpen":"_3VnsaeI"};


//////////////////
// WEBPACK FOOTER
// ./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css
// module id = ./template/components/NotQuiteStickyHeader/NotQuiteStickyHeader.css
// module chunks = client.sitechrome